import React from 'react';
import ThemedComponent from '@hoc/ThemedComponent';

import { default as FlowsPageViewDefaut } from './FlowsPage/View';
import { default as FlowsPageView3 } from '@themes/3/pages/flows/FlowsPage';
import { default as FlowsPageView4 } from '@themes/4/pages/flows/FlowsPage';

import { default as FlowPageViewDefault } from './FlowPage/View';
import { default as FlowPageView4 } from '@themes/4/pages/flows/FlowPage';

import { default as CreateFlowPageViewDefault } from './CreateFlowPage/View';
import { default as CreateFlowPageView4 } from '@themes/4/pages/flows/CreateFlowPage';

const ThemedFlowsPage = {
  default: FlowsPageViewDefaut,
  // 3: FlowsPageView3,
  // 4: FlowsPageView4,
};

const ThemedFlowPage = {
  default: FlowPageViewDefault,
  // 4: FlowPageView4,
};

const ThemedCreateFlowPage = {
  default: CreateFlowPageViewDefault,
  // 4: CreateFlowPageView4,
};

export const FlowsPageView = ThemedComponent(ThemedFlowsPage);

export const FlowPageView = ThemedComponent(ThemedFlowPage);

export const CreateFlowPageView = ThemedComponent(ThemedCreateFlowPage);
